import React from "react";
import { Formik } from "formik";
import Grid from "@mui/material/Grid";
import { AutoSaveField as Field, SelectAutocomplete } from "../../../../../components/Form";
import { ContinueButton } from "../../../../../components/Buttons/ContinueButton";
import { ContinueBtn, FormStyle } from "../styled";
import { ScrollToError } from "components/ScrollToError";

/**
 * Industry component displays and manages the industry information form.
 * @param {Object} props
 * @param {Function} props.handleContinue - Callback for form submission.
 */
const initialValues = {
  businessActivity: "",
  businessModel: ""
};

export const Industry = ({ handleContinue }) => {
  const roProspectPath = "roProspect.organizationInfoRO";

  return (
    <Formik initialValues={initialValues} validateOnChange={false} onSubmit={handleContinue}>
      <FormStyle>
        <ScrollToError />
        <Grid container spacing={3} mb={2}>
          <Grid item sm={12} xs={12}>
            <Field
              name="businessActivity"
              label="Company business activity as per trade license"
              path={`${roProspectPath}.companyBusinessAsPerTL`}
              component={SelectAutocomplete}
              datalistId="YesNoList"
              InputProps={{
                inputProps: { tabIndex: 0, "data-testid": "business-activity-select" }
              }}
            />
          </Grid>
          <Grid item sm={12} xs={12}>
            <Field
              name="businessModel"
              label="Business model as per actual activity"
              path={`${roProspectPath}.businessModelAsperActual`}
              component={SelectAutocomplete}
              datalistId="YesNoList"
              InputProps={{
                inputProps: { tabIndex: 0, "data-testid": "business-model-select" }
              }}
            />
          </Grid>
        </Grid>

        <Grid container direction="row" justifyContent="flex-end" mb={2}>
          <ContinueBtn>
            <ContinueButton type="submit" data-testid="continue-button" />
          </ContinueBtn>
        </Grid>
      </FormStyle>
    </Formik>
  );
};
